export default dsf.component({
  name: "DsfTitle",
  mixins: [$mixins.text],
  inheritAttrs: false,
  ctrlCaption: "标题",
  props: {
    value: {
      type: [String, Number],
      default: "标题"
    },
    fontType: {
      type: [Number, String],
      default: 1
    },
    showColorLump: {
      type: Boolean,
      default: false
    },
    showUnderline: {
      type: Boolean,
      default: false
    },
    showWeight: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: "left"
    },
    fontFamily: {
      type: String,
      default: ""
    },
    // 右侧图标
    rightIcon: {
      type: String,
      default: ""
    },
    rightText: {
      type: String,
      default: ""
    },
    rightIconColor: {
      type: String,
      default: "#888"
    },
    rightIconBold: {
      type: Boolean,
      default: false
    },
    rightIconConfig: {
      type: Object,
      default: () => ({})
    },
    //是否是标题
    isTitleControl: {
      type: Boolean,
      default: true
    },
    padding:{
      type:Array,
      default(){
        return [8,8,8,8]
      }
    },
    // 富文本模式
    richTextMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editting: false,
      $required: false
    };
  },
  computed: {
    getCss() {
      const $class = this.$getClass();
      $class.push("text-" + this.$textAlign, this.showColorLump ? "ds-showColorLump" : "", "ds_font_" + this.fontFamily, this.$required ? "ds_required" : "");
      return $class;
    },
    getLabelCss() {
      return ["ds-font" + this.fontType, this.showUnderline ? "underline" : "", this.showWeight ? "ds-bold" : ""];
    },
    rightIconStyle() {
      return {
        color: this.$compileColor(this.rightIconColor),
        "font-weight": this.rightIconBold ? "bold" : "normal"
      };
    },
    hasHelper() {
      return !!this.dataCapion;
    },
    $textAlign: {
      get() {
        //以前老版本的值是text-开头，比如text-center，但这样的字符不太友好，改为center,left,right
        let align = this.textAlign || "left";
        if (align.startsWith("text-")) {
          align = align.replace("text-", "");
        }
        return align;
      },
      set(v) {
        let align = v || "left";
        if (align.startsWith("text-")) {
          align = align.replace("text-", "");
        }
        this.$emit("update:textAlign", align);
      }
    }
  },
  watch: {
    richTextMode(to) {
      if (!to) {
        this.__value = this.value;
        let value = new DOMParser().parseFromString(this.value, "text/html").body.innerText || '';
        this.$emit("update:value", value);
      } else {
        this.$emit("update:value", this.__value || this.value);
      }
    }
  },
  render(h) {
    return this.renderHandler(h);
  },
  methods: {
    renderHandler(h) {
      let children = [];
      if (!this.isDesign) {
        children.push(this.renderNormal(h));
      } else if (!this.editting || this.richTextMode) {
        children.push(this.renderNotEdit(h));
      } else {
        children.push(this.renderEdit(h));
      }
      // 右侧图标
      children.push(
        <div class="ds-title-box-right">
          { this.$slots.default }
        </div>,
        <div class={['right-icon', 'iconfont', 'icon-' + this.fontType]} style={this.rightIconStyle} onClick={this.rightIconClick}>
          { this.rightText ? (<span>{this.rightText}</span>) : null }
          { this.rightIcon ? (<i class={["ds-title-box-right-icon", "iconfont", this.getIcon(this.rightIcon)]}/>) : null}
        </div>
      );

      let classList = ["ds-control ds-title-box ds-no-padding", this.getCss];
      let events = {};
      if (this.isDesign) {
        events['dblclick'] = this.beginEdit;
      }
      return (
        <div class={classList} style={this.getStyle} on={events}>
          { children }
        </div>
      );
    },
    // 非设计器模式渲染
    renderNormal(h) {
      let children = [];
      if (this.richTextMode) {
        return (
          <div class="ds-title-ueditor" style="width: 100%" domProps={{innerHTML: dsf.safe.xss(this.value)}}></div>
        );
      } else if (this.hasHelper && this.dataCapionTarget == 'text') {
        if (this.dataCapionType == 'hoverPop' || this.dataCapionType == 'clickPop') {
          children.push(
            <el-popover
              class="ds_label-helper"
              placement="top"
              title=""
              width="200"
              trigger={this.dataCapionType == 'hoverPop' ? 'hover' : 'click'}>
              <span slot="reference" class="ds_label-text" style={{color: this.realColor}}>{ this.value }</span>
              <div domProps={{innerHTML: dsf.safe.xss(this.dataCapion)}}></div>
            </el-popover>
          );
        } else {
          children.push(
            <span class="ds_label-text" style={{color: this.realColor}} onClick={this.showHelper}>
              {this.value}
            </span>
          );
        }
      } else {
        children.push(
          <span class="ds_label-text" style={{color: this.realColor}}>
            {this.value}
          </span>
        );
      }
      if (this.$slots.helper) {
        children.push(this.$slots.helper);
      } else if (this.hasHelper && this.dataCapionTarget == 'icon') {
        if (this.dataCapionType == 'hoverPop' || this.dataCapionType == 'clickPop') {
          children.push(
            <el-popover
              class="ds_label-helper"
              placement="top"
              title=""
              width="200"
              trigger={this.dataCapionType == 'hoverPop' ? 'hover' : 'click'}>
              <i slot="reference" class="iconfont icon-bangzhuzhongxin"></i>
              <div domProps={{innerHTML: dsf.safe.xss(this.dataCapion)}}></div>
            </el-popover>
          );
        } else {
          children.push(
            <i class="iconfont icon-bangzhuzhongxin ds_label-helper" onClick={this.showHelper}></i>
          );
        }
      }
      return (
        <label class={["ds_label", this.getLabelCss]}>
          { children }
        </label>
      );
    },
    // 设计器下普通编辑模式
    renderEdit(h) {
      let classList = [
        'ds-font' + this.fontType,
        this.showWeight ? 'ds-bold':'',
        'ds_font_' + this.fontFamily
      ];
      return (
        <el-input ref="contenteditable" v-model={this.value} style={{color: this.realColor}} class={classList} type="textarea" autosize placeholder="请输入内容" resize="none" onblur={this.endEdit} />
      );
    },
    // 设计器下非编辑模式
    renderNotEdit(h) {
      if (this.richTextMode) {
        return (
          <div class="ds-title-ueditor" style="width: 100%" domProps={{innerHTML: dsf.safe.xss(this.value)}}></div>
        );
      }
      let classList = [
        "ds_label ds_label-box pc",
        this.getLabelCss
      ];
      let helper = this.$slots.helper;
      if (!helper && this.hasHelper && this.dataCapionTarget == 'icon') {
        helper = (<i class="iconfont icon-bangzhuzhongxin ds_label-helper"></i>);
      }
      return (
        <label class={classList}>
          <span class="ds_label-text" style={{color: this.realColor}}>{this.value || '无内容'}</span>
          { helper }
        </label>
      );
    },
    beginEdit() {
      this.__startValue = this.value;
      if (this.richTextMode) {
        dsf.designer.triggerDialogPropty("value");
      } else {
        this.editting = true;
        this.$nextTick(() => {
          window.setTimeout(() => {
            this.$refs.contenteditable && this.$refs.contenteditable.focus();
          }, 100);
        });
      }
    },
    endEdit(e) {
      if (this.isDesign) {
        this.editting = false;
        let v = e.target.value;
        if (this.__startValue != v) {
          // 记录页面修改
          this.$designer.recordPageChange();
        }
      }
    },
    getIcon(icon) {
      if (!icon || icon == "") return "";
      return !icon.indexOf("icon-") ? icon : "icon-" + icon;
    },
    rightIconClick() {
      if (this.rightIconConfig && !this.rightIconConfig.title) {
        this.rightIconConfig.title = this.title;
      }
      this.$open({ ...this.rightIconConfig });
    }
  },
  design: {
    defaultInitProps() {
      return {
        textAlign: dsf?.config?.component?.DsfTitle?.textAlign
      };
    }
  }
});